<template>
  <div class="source-dialog-header">
    <md-input-container>
      <md-input
        :value="value.url"
        :disabled="disabled"
        @input="setValue('url', arguments[0])"
        placeholder="Укажите ссылку на статью в elibrary или ссылку на электронный ресурс"
      ></md-input>
      <md-button
        class="md-raised md-primary load-source"
        :disabled="disabled"
        @click.native="onLoadSource"
      >
        Загрузить данные
      </md-button>
    </md-input-container>
    <div class="type-select">
      <md-radio
        v-for="option in typeOptions"
        :key="option.key"
        :value="value.type"
        :md-value="option.key"
        :disabled="disabled"
        @input="setValue('type', arguments[0])"
      >{{ option.title }}</md-radio>
    </div>
  </div>
</template>

<script>
import { elibraryRegExp } from '@/shared/resoucesRegexps.js'

export default {
  name: 'SourceDialogHeader',
  props: {
    value: Object,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      typeOptions: [
        {
          key: 'article',
          title: 'Статья'
        },
        {
          key: 'book',
          title: 'Книга'
        },
        {
          key: 'resource',
          title: 'Электронный ресурс'
        }
      ]
    }
  },

  methods: {
    onLoadSource () {
      const value = this.value.url
      if (elibraryRegExp.test(value)) {
        const id = value.replace(elibraryRegExp, '$2')
        this.$emit('load-article', id)
      } else {
        this.$emit('load-digital-resource', value)
      }
    },
    setValue (field, value) {
      this.$emit('input', {...this.value, [field]: value})
    }
  }
}
</script>


// WEBPACK FOOTER //
// SourceDialogHeader.vue?c79d8512